export default "__VITE_ASSET__BfaeHusl__"